import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { BeneficiaryId } from "../../Types";
import ValidationError from "../../ZodError";
export const BeneficiaryContactInformation = z.object({
    emailAddress: z.string().nullable(),
    phoneNumber: z.string().nullable(),
});
const Response = z.object({
    beneficiaryId: BeneficiaryId,
});
export const url = (clientId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/entity/v1/clientside/${clientId}/beneficiaries`
        : `https://middleware.uat.farther.com/entity/v1/clientside/${clientId}/beneficiaries`;
};
export default async function postClientBeneficiary(clientId, body, config) {
    const { data } = await axios.post(url(clientId), body, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `${postClientBeneficiary.name} returned unexpected data.`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=postClientBeneficiary.js.map